// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/RatingsScorecard/ratingsScorecard.scss
// module id = 1417
// module chunks = 10